import {useState} from "react";
import {useTranslation} from "react-i18next";
import {Box, Modal} from "@mui/material";

import CourseLogosList from "../components/CourseLogosList";
import CourseLogoForm from "../components/CourseLogoForm";
import {useAlert} from "../context/AlertContext";
import {ApiError} from "../types/api-errors";

const AdminCourseLogosPage = () => {
    const {t} = useTranslation();
    const {showAlert} = useAlert();

    const [open, setOpen] = useState(false);
    const [refresh, setRefresh] = useState(false);

    const refreshCourseLogos = () => {
        setRefresh((previous) => !previous);
    };

    const handleLogoAdded = () => {
        setOpen(false);
        refreshCourseLogos();

        showAlert(
            t("courselogoslist.alerts.created"),
            "success"
        );
    };

    const handleError = (error: ApiError | any) => {
        const message =
            typeof error === "string"
                ? error
                : error?.message ??
                t("courselogoslist.errors.unexpected");

        showAlert(message, "error");
    };

    return (
        <Box sx={{px: {xs: 3, md: 3}}}>
            <CourseLogosList
                onAdd={() => setOpen(true)}
                refreshTrigger={refresh}
                refreshCourseLogos={refreshCourseLogos}
            />

            <Modal
                open={open}
                onClose={() => setOpen(false)}
            >
                <Box
                    sx={{
                        margin: "auto",
                        width: {
                            xs: "100%",
                            sm: 650,
                        },
                        maxWidth: "100%",
                    }}
                >
                    <CourseLogoForm
                        onClose={() => setOpen(false)}
                        onSuccess={handleLogoAdded}
                        onError={handleError}
                    />
                </Box>
            </Modal>
        </Box>
    );
};

export default AdminCourseLogosPage;